

import react, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import NavBar from "../../../../components/NavBar";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Puff } from "react-loading-icons";
import EventTicketsRequest from './EventTicketsRequest'
import { Grid, EstadoCellRenderer } from "../../../Layout/Grid/GridView";

const EventTicketsTransaction = () => {
    let params = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const gridRef = useRef();
    const [state, setState] = useState({
        tickets: [],
        event: {
            id: 0,
            name: "",
            id_venues: "",
        },
        modalFormTableReservation: {
            show: false,
            data: {
                table: {},
            },
        },
        modalFormTableReservationInfo: {
            show: false,
            data: {
                table: {},
            },
        },
    });

    useEffect(() => {
        document.title = "Event Tickets | Nightspot Dashboard";
        getEventTicketsTransactionList();
    }, []);

    const getEventTicketsTransactionList = async (closeFormTableReservation = false) => {
        setIsLoading(true);
        let info = await EventTicketsRequest.getEventTicketsTransactionList({
            id_events: params.id,
        });
        if (info && info.status) {
            setState(info.data);
        }
        setIsLoading(false);
    };


    const InsideLoading = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    flexDirection: "column",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                    }}
                >
                    <Puff stroke="#333" height="5em" width="5em" />
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                    }}
                >
                    Loading...
                </div>
            </div>
        );
    };


    return (
        <div>
            <NavBar>
                <div className="row">
                    <div className="col-sm-12 dashboard-content">
                        {isLoading ? (
                            <InsideLoading />
                        ) : (
                            <>
                                <div className="row">
                                    <div className="col-12">
                                        <nav>
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <Link to="/my/dashboard">
                                                        <i className="fa-solid fa-home"></i>
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item">
                                                    <Link to="/my/events/">Eventos</Link>
                                                </li>
                                                <li className="breadcrumb-item">
                                                    <Link to={`/my/events/${params.id}/tickets`}>
                                                        Supervisão Bilhetes
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item active">
                                                    Lista Tranferências
                                                </li>
                                            </ol>
                                        </nav>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-7">
                                        <h2 className="dashboard-h2">
                                            Evento: {state.event.name}{" "}
                                            <small style={{ color: "#ea2c61" }}>|</small>{" "}
                                            <small style={{ fontWeight: "100" }}>
                                                {state.event.date_formated}
                                            </small>
                                        </h2>
                                    </div>
                                    {/* <div className="col-12 col-sm-5 ">
                                        <Link
                                            className="btn btn-primary float-end ms-3"
                                            to={`/my/events/${state.event.id}/tickets/transactions-list`}
                                        >
                                            <i className="fa-solid fa-file-download"></i>
                                            &nbsp;Exportar tabela
                                        </Link>
                                    </div> */}
                                </div>
                                <div className="row mt-3">
                                    <div className="col-12">
                                        <Grid
                                            ref={gridRef}
                                            rows={state.transactions}
                                            cols={[
                                                { hide: true, field: "id" },
                                                { headerName: "Data", field: "transaction_date" },
                                                { headerName: "Cliente", field: "client_name" },
                                                { headerName: "Email", field: "owner_email" },
                                                { headerName: "Contribuinte", field: "owner_vat_number" },
                                                { headerName: "Valor (€)", cellStyle: { textAlign: "right" }, field: "transaction_price_ticket" },
                                                { headerName: "Data Pagamento", field: "payment_datetime" },
                                                {
                                                    headerName: "Método Pagamento",
                                                    field: "payment_method",
                                                    cellRenderer: (params) => {
                                                        return (
                                                            <div className="text-center">
                                                                <img
                                                                    src={`/img/payments/${params.data.payment_method}.png`}
                                                                    className="img-fluid"
                                                                    style={{ height: "25px", width: "auto" }}
                                                                />
                                                            </div>
                                                        );
                                                    },
                                                },

                                            ]}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>

            </NavBar>
        </div>
    );

}

export default EventTicketsTransaction;
